export function localpartOf(userId: string | null): string {
  return /^@([^:]+):/.exec(userId ?? "")?.[1] ?? "";
}

export function mostFrequentName(names: string[], localpart: string): string | null {
  const counts = new Map<string, number>();
  for (const name of names) {
    const value = name.trim();
    if (!value || value === localpart) continue;
    counts.set(value, (counts.get(value) ?? 0) + 1);
  }
  let best: string | null = null;
  let bestCount = 0;
  for (const [value, count] of counts) {
    if (count > bestCount) {
      bestCount = count;
      best = value;
    }
  }
  return best;
}

export function preferredAccountLabel(
  accountName: string | null,
  globalDisplayName: string | null,
  localpart: string,
): string | null {
  const account = accountName?.trim();
  if (account) return account;
  const global = globalDisplayName?.trim();
  if (global && global !== localpart) return global;
  return null;
}

export function resolveAccountLabel(input: {
  accountName: string | null;
  globalDisplayName: string | null;
  memberNames: string[];
  localpart: string;
}): string | null {
  const preferred = preferredAccountLabel(
    input.accountName,
    input.globalDisplayName,
    input.localpart,
  );
  if (preferred) return preferred;
  const fromMembers = mostFrequentName(input.memberNames, input.localpart);
  if (fromMembers) return fromMembers;
  return input.localpart || null;
}
